// Sentry configuration for Trafomatic Connect
// Документація: https://docs.sentry.io/platforms/javascript/guides/react/

import * as Sentry from "@sentry/react";

// Ініціалізувати Sentry тільки якщо DSN налаштований
const sentryDsn = (
  import.meta as { env?: { VITE_SENTRY_DSN?: string; MODE?: string } }
).env?.VITE_SENTRY_DSN;
const mode =
  (import.meta as { env?: { MODE?: string } }).env?.MODE || "development";

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: mode === "production" ? 0.1 : 1.0,

    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% сесій
    replaysOnErrorSampleRate: 1.0, // 100% сесій з помилками

    environment: mode,

    beforeSend(event) {
      // Фільтрувати чутливі дані
      if (event.request?.headers) {
        delete event.request.headers["Authorization"];
        delete event.request.headers["apikey"];
      }
      return event;
    },
  });

  console.log("✅ Sentry initialized successfully");
} else {
  console.warn(
    "⚠️ Sentry DSN not configured. Set VITE_SENTRY_DSN in .env to enable error logging.",
  );
}

// ІНСТРУКЦІЯ ПО НАЛАШТУВАННЮ:
// 1. Створити проект на https://sentry.io
// 2. Скопіювати DSN з налаштувань проекту
// 3. Додати в .env або .env.local:
//    VITE_SENTRY_DSN=https://your-key@your-org.ingest.sentry.io/your-project-id
// 4. Перезапустити dev сервер
// 5. Тепер всі помилки будуть автоматично логуватися в Sentry
